import createHistory from 'history/createBrowserHistory'
import scrollMiddleware from './scrollMiddleware'
import store from './../store'

const history = createHistory()

var middlewares = [
  scrollMiddleware,
]
  .map(f => f(history, store))

/**
 * The navigation state is stored in the url and
 * browser history instead of in redux state. Rather than copying all that
 * state into redux to be able to use redux middleware and then keeping it in
 * sync this file acts as middleware that interacts with the browser history
 * state exclusively .
 */
history.listen((location, action) => {
  middlewares.forEach(m => m(location, action))
})
export default history



// WEBPACK FOOTER //
// ./src/history/history.js